import * as React from 'react';
import {Query} from 'react-apollo';

import type {
    EmailStats as EmailStatsFragment,
    GetEmailStats as GetEmailStatsQuery,
} from 'nutshell-graphql-types';

import {hasEmailSequenceAutomation} from '../has-email-sequence-automation';

import {EmailStatusButton} from './email-status-button';
import GET_EMAIL_STATS from './graphql/queries/email-stats-query.graphql';
import {ToggleAutomatedEmailSendingButton} from './toggle-automated-email-sending-button';

class EmailStatQuery extends Query<GetEmailStatsQuery, Record<any, any>> {}

type Props = {
    emailStats: EmailStatsFragment | null | undefined;
};

class EmailHealthRootComponent extends React.PureComponent<Props> {
    button: HTMLElement | null | undefined;

    render() {
        if (!this.props.emailStats) return null;

        return (
            // Better than a wrapping div, so that our buttons
            // are all adjacently inline-block with the same height
            <>
                {NutClientConfig.hasConfiguredEmail && hasEmailSequenceAutomation() ? (
                    <ToggleAutomatedEmailSendingButton
                        isSendingPaused={this.props.emailStats.isAutomatedSendingPaused}
                    />
                ) : undefined}
                <EmailStatusButton emailStats={this.props.emailStats} />
            </>
        );
    }
}

export const EmailHealthRoot = () => (
    <EmailStatQuery query={GET_EMAIL_STATS}>
        {({data}) => {
            return <EmailHealthRootComponent emailStats={data && data.emailStats} />;
        }}
    </EmailStatQuery>
);
